import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Project  {
    _originalTypeClassName = "zERP.BO.Project";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Project.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this.StartDate = null;
this.EndDate = null;
this.Budget = null;
this.IsCompleted = false;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
StartDate:any;
EndDate:any;
Budget:any;
IsCompleted:any;
Code:any;
EmployeeProjectManager:any;
TransactionEntityClient:any;
static setEmployeeProjectManager = ($this, value) => {
var oldValue = $this.EmployeeProjectManager;
$this.EmployeeProjectManager = value;
if (value != null) {
}
}
static setTransactionEntityClient = ($this, value) => {
var oldValue = $this.TransactionEntityClient;
$this.TransactionEntityClient = value;
if (value != null) {
if (oldValue != null) {
Domain.TransactionEntity.removeProjects(oldValue, $this);
}
Domain.TransactionEntity.addProjects(value, $this);
}
}

static GetClassName(): any{return "Project";
}
static ParseIsCompleted(cmp: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((cmp ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(cmp)) && cmp == "ΝΑΙ" ? true : false);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}